import { render, staticRenderFns } from "./SapData.vue?vue&type=template&id=db09c7a0&scoped=true"
import script from "./SapData.vue?vue&type=script&lang=js"
export * from "./SapData.vue?vue&type=script&lang=js"
import style0 from "./SapData.vue?vue&type=style&index=0&id=db09c7a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db09c7a0",
  null
  
)

export default component.exports